module.exports = __webpack_public_path__ + "img/mysql.2addb310.svg";